module.exports = __webpack_public_path__ + "img/cm1.140f4a62.png";